module.exports = __webpack_public_path__ + "img/oil.866db00f.png";